/**
 * The status chip of an occasion splash (splash-cms §1 part 3). Off whenever it is switched off,
 * whatever its dates; otherwise Live now inside `[startsAt, endsAt)` (UTC, start inclusive, end
 * exclusive — the server's overlap rule uses the same half-open window), Scheduled before it and
 * Ended after it.
 */
export type SplashStatus = "live" | "scheduled" | "ended" | "off";

export const SPLASH_STATUS_LABELS: Record<SplashStatus, string> = {
  live: "Live now",
  scheduled: "Scheduled",
  ended: "Ended",
  off: "Off",
};

export interface SplashWindow {
  isActive?: boolean;
  startsAt?: string;
  endsAt?: string;
}

export function splashStatus(splash: SplashWindow, now: Date): SplashStatus {
  if (splash.isActive !== true) return "off";
  const at = now.getTime();
  if (at >= Date.parse(splash.endsAt ?? "")) return "ended";
  if (at >= Date.parse(splash.startsAt ?? "")) return "live";
  return "scheduled";
}
